'use client';

import { Link } from '@packages/modules/src/Link/Link';
import { useIntl } from 'react-intl';
import type { Download } from '@packages/gql/generated/shopping/graphql';
import { downloadItemMessages } from './messages';

export type DownloadItemProps = Pick<Download, 'link' | 'type'> & {
  /**
   * Decides wether or not the download icon should be rendered
   * @default true
   */
  renderIcon?: boolean;
  /**
   * Optional - additional text next to the message.
   */
  linkTextExtension?: number | string;
};

/**
 * The Download component is used to display a link with or without an icon.
 * The link is clickable and opens a downloadable file in a new tab.
 * */
export const DownloadItem = ({
  link,
  type,
  renderIcon = true,
  linkTextExtension,
}: DownloadItemProps) => {
  const { formatMessage } = useIntl();

  // if there is a new DownloadType, which is missing in messages, we return null
  if (!(type in downloadItemMessages)) {
    return null;
  }

  return (
    <Link
      href={link}
      openInNewTab
      className={`flex items-center gap-1 ${renderIcon ? 'text-size-body-sm' : 'text-size-body-xs underline'}`}
    >
      {renderIcon && <span className="icon-emp-pdf decor text-size-headline-2xl" />}
      {formatMessage(downloadItemMessages[type])} {linkTextExtension}
    </Link>
  );
};
